import controller from './product-detail.controller';
import templateT1 from './templates/product-detail-t1.view.html';
import templateAD from './templates/product-detail-view-adaptative.html';

let ProductDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative){
       return templateAD;
    } else {
        return templateT1;
    }
}

export default ProductDetailComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/product-detail/product-detail.component.js
 **/